import { render, staticRenderFns } from "./Bao.vue?vue&type=template&id=56a1f1e4"
import script from "./Bao.vue?vue&type=script&lang=js"
export * from "./Bao.vue?vue&type=script&lang=js"
import style0 from "./Bao.vue?vue&type=style&index=0&id=56a1f1e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports